var {AmpersandApp: productCatalogApp, AmpersandView} = require('catalog/libs');

var HPEServices = require('../../../base/hpe.services');
var HPEConstants = require('../../../base/hpe.constants');

var cardTemplate = require('../templates/hpe.productlist.card.tpl');
var cardListView = require('./hpe.productlist.productcard.speclist.view');

/**
 * Product Card view
 */
module.exports = AmpersandView.extend({
	template: cardTemplate,
	initialize: function() {

		productCatalogApp.on('SPECS_CHANGE', function (shouldShowSpecs) {
			this.model.showSpecs = shouldShowSpecs.specTrigger;
		}.bind(this));
		//HPEServices.subscribe(HPEConstants.catalog.SPECS_CHANGE, this, function(shouldShowSpecs) {
		//	this.model.showSpecs = shouldShowSpecs;
		//});

	},
	subviews: {
		firstThird: {
			selector: '[data-hook=spec-first-third]',
			waitFor: 'model.speclistFirstThird',
			prepareView: function () {
				return this.renderCollection(this.model.speclistFirstThird, cardListView, this.el.querySelector('[data-hook=spec-first-third]'));
			}
		},
		lastThird: {
			selector: '[data-hook=spec-last-third]',
			waitFor: 'model.speclistLastThird',
			prepareView: function () {
				return this.renderCollection(this.model.speclistLastThird, cardListView, this.el.querySelector('[data-hook=spec-last-third]'));
			}
		}
	},
	bindings: {
		'model.updated': {
			type: 'toggle',
			selector: '.product-status.updated-product'
		},
		'model.new': {
			type: 'toggle',
			selector: '.product-status.new-product'
		},
		'model.labelPrice': {
			type: 'text',
			selector: '.pricing-info-text'
		},
		'model.labelCompare': {
			type: 'text',
			selector: '.checkbox-text-label'
		},
		'model.labelNew': {
			type: 'text',
			selector: '.product-status.new-product'
		},
		'model.labelUpdated': {
			type: 'text',
            selector: '.product-status.updated-product'

		},
		'model.prodname': [
			{
				type: 'attribute',
				name: 'alt',
				selector: '.product-image'
			},
			{
				type: 'text',
				selector: '.product-name'
			}
		],
		'model.images[0].image_url_https': {
			type: function (el, value) {
                if (value) {
					el.src = value;
                }
            },
			selector: '.product-image'
		},
		'model.oid': {
			type: 'attribute',
			name: 'id',
			selector: '.product-wrapper'
		},
		'model.compareId': [
			{
				type: 'attribute',
				name: ['id', 'name'],
				selector: '.focus-handler'
			},
			{
				type: 'attribute',
				name: 'for',
				selector: '.checkbox-helper'
			},
			{
				type: 'attribute',
				name: 'for',
				selector: '.checkbox-text-label'
			}
		],
		'model.primaryPrice': [
			{
				type: 'text',
				selector: '.price'
			},
			{
				type: function	(el, value) {

                    var showPrice;
                    if (window.hpePriceConfig) {
                        showPrice = window.hpePriceConfig.showPrice;
                    }
                    if (value !== '0' && value !== undefined && window.hpePriceConfig && showPrice !== 'false') {
                        $(el).find('.price').append("<span class='price-note'> *</span>");
                        el.style.display = 'block';
                    } else {
                        el.style.display = 'none';
                    }

					// var priceConfig = document.querySelector('[data-currency-format]');
					// var showPrice;
					// if (priceConfig) {
					// 	showPrice = priceConfig.getAttribute('data-show-price');
					// }
					// if (value !== '0' && priceConfig && showPrice !== 'false') {
					// 	el.style.display = 'block';
					// } else {
					// 	el.style.display = 'none';
					// }
				},
				selector: '.product-primary-pricing'
			}
		],
		'model.primaryPriceLabel': {
			type: 'text',
			selector: '.primary-pricing-label'
		},
		'model.secondaryPrice': [
			{
				type: 'text',
				selector: '.secondary-price'
			},
			{
				type: function	(el, value) {

                    var smbPrice;
                    var showPrice;
                    if (window.hpePriceConfig) {
                        smbPrice = window.hpePriceConfig.smbPrice;
                        showPrice = window.hpePriceConfig.showPrice;
                    }

                    if (value !== '0' && value !== undefined && window.hpePriceConfig && smbPrice === 'true' && showPrice !== 'false') {
                        $(el).find('.secondary-price').append("<span class='price-note'> *</span>");
                        el.style.display = 'block';
                    } else {
                        el.style.display = 'none';
                    }

					// var priceConfig = document.querySelector('[data-currency-format]');
					// var smbPrice;
					// var showPrice;
					// if (priceConfig) {
					// 	smbPrice = priceConfig.getAttribute('data-show-smb-price');
					// 	showPrice = priceConfig.getAttribute('data-show-price');
					// }

					// if (value !== '0' && priceConfig && smbPrice === 'true' && showPrice !== 'false') {
					// 	el.style.display = 'block';
					// } else {
					// 	el.style.display = 'none';
					// }
				},
				selector: '.product-secondary-pricing'
			}
		],
		'model.secondaryPriceLabel': {
			type: 'text',
			selector: '.secondary-pricing-label'
		},
		'model.sku': [
			{
				type: 'text',
				selector: '.product-sku'
			},
			{
				type: function (el, value) {
					if (value) {
						el.style.display = 'none';
					} else {
						el.style.display = 'block';
					}
				},
				selector: '.pricing-info-text'
			}
		],
		'model.categoryLabel': {
			type: 'text',
			selector: '.product-category'
		},
		'model.productURL': {
			type: 'attribute',
			name: 'href',
			hook: 'product-url'
		},
		'model.cta': [
			{
				type: 'text',
				selector: '.cta-button'
			},
			{
				type: function(el, value) {
					if (!value) {
						el.style.display = 'none';
					}
				},
				selector: '.cta-button'
			}
		],
		'model.ctaURL': {
			type: 'attribute',
			name: 'href',
			selector: '.cta-button'
		},
		'model.compare': {
			type: function(el, value) {
				if (value !== true) {
					el.parentNode.removeChild(el);
				}
			},
			hook: 'compare-product'
		},
		'model.showSpecs': {
			type: 'booleanClass',
			selector: '.product-specs-wrapper',
			name: 'shown'
		},
        'model.specsEmpty': {
            type: 'booleanClass',
            selector: '.product-specs-wrapper',
            name: 'empty'
        },
		'model.isCompareChecked': [
            {
                type: function(el, value) {
					el.checked = value;
                },
                selector: 'input'
            },
            {
                type: 'booleanClass',
                selector: '.checkbox-input',
                name: 'active'
            },
            {
                type: 'attribute',
                selector: '.checkbox-input',
                name: 'aria-checked'
            }
        ],
		'model.isCompareDisabled': [
            {
                type: function(el, value) {
					el.disabled = value;
                },
                selector: '.checkbox-input input'
            },
            {
                type: 'booleanClass',
                selector: '.checkbox-input',
                name: 'disabled'
            },
            {
                type: 'attribute',
                selector: '.checkbox-input',
                name: 'aria-disabled'
            }
        ]
	},

	/**
	 * events
	 */
    events: {
        'change input': 'onCompareCheckboxClick',
        'keyup .input-selectable': 'onFilterKeyUp'
    },

    /**
     * handle key up event on checkbox
     * @param {object} e event object
     */
    onFilterKeyUp: function(e) {

		e.preventDefault();
		e.stopPropagation();

        //watch for space and return to change state of checkbox
		if (!this.model.isCompareDisabled) {
			if ((e.keyCode === 13) || (e.keyCode === 32)) {
				this.model.isCompareChecked = !this.model.isCompareChecked;
				this.onAddToCompareChange(this.model.isCompareChecked);
			}
		}
    },

    /**
     * handle user interaction with "add to compare" checkbox
     * @param {object} e event object
     */
    onCompareCheckboxClick: function(e) {
		this.onAddToCompareChange(e.target.checked);
    },

    /**
     * handle compare change event
     * @param  {Boolean} isChecked if checkbox is checked or not
     */
    onAddToCompareChange: function(isChecked) {

		var compareChange = {
			oid: this.model.oid,
			prodname: this.model.prodname,
            prodnameurl: this.model.prodnameurl,
			produrl: this.model.productURL,
            'new': this.model.new,
			updated: this.model.updated
		};

		//broadcast compare add or remove event with data payload
		if (isChecked) {
			HPEServices.publish(HPEConstants.catalog.COMPARE_LIST_ADD, compareChange);
		} else {
			HPEServices.publish(HPEConstants.catalog.COMPARE_LIST_REMOVE, compareChange);
		}
    }
});
